import { Component, OnInit, Input } from '@angular/core';
import { LookupsService } from '../../shared/services/lookups.service';
import { NotificationsService } from '../../shared/services/notifications.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-transfer-notification',
  templateUrl: './transfer-notification.component.html',
  styleUrls: ['./transfer-notification.component.scss']
})
export class TransferNotificationComponent implements OnInit {

  @Input() selection: any[] = [];

  users: any[] = [];
  selectedUser: any = null;

  invalidSelection: boolean = true;
  isLoading: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    lookupsService: LookupsService,
    private notificationsService: NotificationsService)
  {
    lookupsService.getAllInternalUsers().subscribe(results => {
      this.users = results
        .map(user => ({ name: user.firstName + ' ' + user.lastName, id: user.id }))
        .sort((a, b) => a.name.localeCompare(b.name));
    });
  }

  ngOnInit(): void {}

  selectionUpdated() {
    this.invalidSelection = this.selectedUser == null;
  }

  transferNotifications() {
    this.isLoading = true;

    this.notificationsService.transferNotifications(
      this.selectedUser.id,
      this.selection.map((x: any) => x.id)
    ).subscribe({
      next: () => {
        this.activeModal.close(true);
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }

  cancel() {
    this.activeModal.close(false);
  }
}